<template>
  <section v-if="Object.keys(mail).length > 0" id="generator__result" class="column center">
    <h2>{{ t('generator_output_h2') }}</h2>

    <div class="box__shadow result__container highlight__extra">
      <h4>{{ mail.subjectLine }}</h4>

      <p>{{ mail.body.intro }}</p>
      <p>{{ mail.body.compliment }}</p>
      <p>{{ mail.body.problem }}</p>
      <p>{{ mail.body.solution }}</p>
      <p>{{ mail.body.cta }}</p>

      <div class="copy__clipboard__btn row center" @click="copyToClipboard">
        <i
          v-motion
          :initial="{ opacity: 0 }"
          :enter="{ opacity: 1 }"
          v-if="coppied"
          class="fa-solid fa-check"
        ></i>
        <i
          v-motion
          :initial="{ opacity: 0 }"
          :enter="{ opacity: 1 }"
          v-else
          class="fa-solid fa-paste"
        ></i>
      </div>

      <div class="remaining__mails row center">{{ 3 - generatedMails }}/3 {{ t('Remaining') }}</div>
    </div>
  </section>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'MailResult',
  setup() {
    const store = useStore()
    const coppied = ref(false)
    const generatedMails = computed(() => store.getters.getGeneratedMails)
    const mail = computed(() => store.getters.getSalesMail)

    const copyToClipboard = async () => {
      await navigator.clipboard.writeText(`${mail.value.subject} \n\n${mail.value.body}`)

      coppied.value = true
      setTimeout(() => {
        coppied.value = false
      }, 2000)
    }

    return {
      coppied,
      generatedMails,
      mail,
      copyToClipboard,
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/media.scss';

#generator__result {
  width: 100%;
  padding: 50px 0 0 0;
  margin: 50px auto 0 auto;

  .result__container {
    position: relative;
    border-radius: 7px;
    padding: 30px;
    width: 500px;
    max-width: calc(90% - 30px);
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    @media #{$mobile} {
      padding: 15px;
    }

    .dynamic__email {
      div {
        padding-top: 15px;
      }

      .subject {
        font-weight: bold;
        margin-top: 10px;

        @media #{$mobile} {
          margin-top: 20px;
        }
      }
    }

    .copy__clipboard__btn {
      position: absolute;
      top: 10px;
      right: 12px;
      width: 30px;
      height: 30px;
      border-radius: 7px;
      font-size: 0.9rem;
      cursor: pointer;
      background-color: var(--highlight-5);

      &:hover,
      &:active {
        background-color: var(--highlight);
      }
    }

    .remaining__mails {
      position: absolute;
      top: 10px;
      left: 15px;
      height: 30px;
      font-size: 0.9rem;
      color: var(--dark-4);
    }
  }
}
</style>
